// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","455":"0e772461","578":"52d3c72d","977":"240addac"}[chunkId] + ".chunk.js";
};